import { ButtonHTMLAttributes, DetailedHTMLProps, useEffect, useState } from 'react';
import { UseRequestState } from '../utils/make-api-request';
import Spinner from './spinner';
import { useUpdateEffect } from '../utils/hooks';

interface Props {
  successMessage?: string;
  failureMessage?: string;
  className?: string;
  request: UseRequestState<unknown>;
}

/**
 * A button with feedback, such as a loading spinner and success and error messages. Does not execute the request on click by default.
 */
const ButtonWithFeedback: React.FC<
  Props & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
> = ({ request, children, className, successMessage, failureMessage, onClick, ...props }) => {
  const [showResult, setShowResult] = useState(false);
  useUpdateEffect(() => {
    // if request just finished (success or error)
    if (!request.fetching) {
      setShowResult(true);
      const timeoutId = window.setTimeout(() => setShowResult(false), 3000);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    return undefined;
  }, [request.fetching]);
  return (
    <button
      onClick={e => {
        onClick?.(e);
      }}
      className={className}
      {...props}
    >
      {request.fetching ? (
        <span className='-mr-2'>
          <Spinner size={18} />
        </span>
      ) : request.data !== undefined && showResult ? (
        successMessage ?? 'Success'
      ) : request.error && showResult ? (
        failureMessage ?? 'Try again'
      ) : (
        children
      )}
    </button>
  );
};

export default ButtonWithFeedback;
